import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Icon,
  IconButton,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
  Select,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import CreateIcon from "@material-ui/icons/Create";

import GridItem from "components/Grid/GridItem.js";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import * as moment from "moment";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { PROJECT, FARMS } from "../../configs/urls";
import { getApi, deleteApi } from "../../services/api";
import { DATE_FORMATS } from "../../configs/constant";
import AppsIcon from "@material-ui/icons/Apps";
import { useHistory } from "react-router-dom";
import ViewSectorOfficer from "../../components/SectorOfficer/viewSectorOffice";
import Toaster from "../../components/Toaster";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

export default function ManageProject() {
  const classes = useStyles();
  const [projects, setProjectsList] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({ page: 0, size: 10 });
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const [viewSectorOfficerData, setViewSectorOfficerData] = useState({
    isDialogOpen: false,
    sectorOfficerList: [],
  });

  const [totalprojectsCount, setTotalprojectsCount] = useState(0);

  useEffect(() => {
    fetchProjects(true);
  }, []); //eslint-disable-line

  const sectorOfficers = projects.map((item) => {
    return item.sector_officers;
  });

  const getSofficers = () => {
    let arr = [];
    for (let item of sectorOfficers) {
      for (let a of item) {
        arr.push({
          id: a.user_details.id,
          project_id: a.project_id,
          name: a.user_details.name,
        });
      }
    }

    var result = arr.reduce((unique, o) => {
      if (!unique.some((obj) => obj.name === o.name && obj.value === o.value)) {
        unique.push(o);
      }
      return unique;
    }, []);

    return result;
  };

  const SOdata = getSofficers();

  const getallSOofficers = () => {
    let arr = [];
    for (let item of sectorOfficers) {
      for (let a of item) {
        arr.push(a);
      }
    }
    return arr;
  };

  const allSQData = getallSOofficers();

  const fetchProjects = (isInitialLoad) => {
    setIsRequestig(true);

    getApi(PROJECT, params)
      .then(
        (res) => {
          if (isInitialLoad) setTotalprojectsCount(res.meta.total);

          const data = res.data || [];
          const newUserList = [...projects, ...data];
          setProjectsList(newUserList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const deleteProjects = (id, idx) => {
    setIsRequestig(true);
    deleteApi(PROJECT + "/" + id)
      .then(
        (res) => {
          let projectsData = projects;
          projectsData.splice(idx, 1);
          setProjectsList(projectsData);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const loadMoreProjects = () => {
    setParams({ ...params, page: (params.page += 1) });
    fetchProjects();
  };

  const handleClickListItem = (event, project) => {
    setAnchorEl(event.currentTarget);
    setSelectedProject(project);
    setViewSectorOfficerData({
      ...viewSectorOfficerData,
      sectorOfficerList: project.sector_officers,
    });
  };

  const handleMenuItemClick = (event, action) => {
    switch (action) {
      case "view_project":
        history.push("/admin/project/view/" + selectedProject.id);
        break;

      case "view_sector_officer":
        if (selectedProject.sector_officers.length > 0) {
          setViewSectorOfficerData({
            ...viewSectorOfficerData,
            isDialogOpen: true,
          });
        } else {
          Toaster.showWarning("Please assign sector officer first");
        }
        break;
      case "edit_project":
        history.push("/admin/project/operations/" + selectedProject.id);
        break;
    }

    setAnchorEl(null);
  };

  const closeViewSectorOfficerDailog = (action, selectedOfficer) => {
    switch (action) {
      case "create_team":
        getApi(FARMS, {
          project_id: selectedProject.id,
          is_team_assigned: 0,
        }).then((res) => {
          if (res.data.length > 0) {
            history.push(
              "/admin/teams/operations/create/" +
                selectedProject.id +
                "/" +
                selectedOfficer.sector_officer_id
            );
          } else {
            Toaster.showWarning("There is no farmer to create team");
          }
        });
        break;
      case "view_team":
        history.push(
          "/admin/jobs/" +
            selectedProject.id +
            "/" +
            selectedOfficer.sector_officer_id
        );
        break;
      case "close":
        setViewSectorOfficerData({
          ...viewSectorOfficerData,
          isDialogOpen: false,
        });
        break;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderProject = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>S.No</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Crop name</TableCell>
            <TableCell>Target in tonnes</TableCell>
            <TableCell>Start date</TableCell>
            <TableCell>End date</TableCell>
            <TableCell>District(s)</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects.map((project, idx) => (
            <TableRow key={idx}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{project.name || "--"}</TableCell>
              <TableCell>{project.crop_name || "--"}</TableCell>
              <TableCell>{project.target_in_tonnes || "--"}</TableCell>
              <TableCell>
                {moment(project.start_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
              <TableCell>
                {moment(project.end_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
              <TableCell>
                {project?.project_district
                  ? project.project_district
                      ?.map((projectDistrict) => projectDistrict.district.name)
                      .join(", ")
                  : "--"}
              </TableCell>

              <TableCell align="center">
                <CreateIcon
                  style={{ cursor: "pointer" }}
                  edge="end"
                  aria-label="menu"
                  className={`${project.draft == 1 ? classes.disable : ""}}`}
                  onClick={(e) => handleClickListItem(e, project)}
                >
                  <AppsIcon />
                </CreateIcon>
                <Menu
                  id="project-menu"
                  anchorEl={anchorEl}
                  elevation={2}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    onClick={(event) =>
                      handleMenuItemClick(event, "view_project")
                    }
                  >
                    View Project
                  </MenuItem>

                  <MenuItem
                    onClick={(event) =>
                      handleMenuItemClick(event, "edit_project")
                    }
                  >
                    Edit Project
                  </MenuItem>

                  <MenuItem
                    onClick={(event) =>
                      handleMenuItemClick(event, "view_sector_officer")
                    }
                  >
                    View sector officer
                  </MenuItem>
                </Menu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/*
        equipments.length < totalUsersCount &&
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreProjects()}
          >
            Load More
          </Button>
        </Grid>
      }*/}
    </TableContainer>
  );

  const [SectorofficerValue, setSectorOfficerValue] = useState();
  const handleChangeSelectOfficer = (e) => {
    e.preventDefault();
    setSectorOfficerValue(e.target.value);
  };
  const getSelectedOfficers = allSQData.filter((item) => {
    return item.sector_officer_id == SectorofficerValue;
  });

  const mapselectedOfficerID = getSelectedOfficers.map((item) => {
    return item.project_id;
  });

  const getProjectsAccToID = () => {
    let arr = [];
    for (let i = 0; i < mapselectedOfficerID.length; i++) {
      const fil = projects.find((item) => {
        return item.id == mapselectedOfficerID[i];
      });
      arr.push(fil);
    }
    return arr;
  };

  const arrData = getProjectsAccToID();
  // useEffect(()=>{
  //     setProjectsList(arrData);
  // }, [SectorofficerValue])

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Projects
            </Typography>
            {/* <p> Sector Officer </p> */}
            {/* <div>
              <label>
                <select
                  onChange={(e) => handleChangeSelectOfficer(e)}
                  style={{ background: "transparent", padding: "5px" }}
                >
                  <option value="" disabled selected>
                    Select Sector Officer
                  </option>

                  {SOdata.map((item) => {
                    return (
                      <option key={item.name} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </label>
            </div> */}

            <div>
              <Link to="/admin/project/operations">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  endIcon={<Icon>add_circle</Icon>}
                >
                  Add Project
                </Button>
              </Link>
            </div>
          </Grid>
          {projects.length ? (
            renderProject()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Project Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
      <ViewSectorOfficer
        sectorOfiicer={viewSectorOfficerData}
        onUpdate={closeViewSectorOfficerDailog}
      />
    </div>
  );
}
